let Util = new function () {

};

Util.checkPostcodeAndNumber = function (postcode, number, numberAddition, country, container, callback) {
    if (!postcode || !number || !country || !callback) {
        return;
    }

    if (!$(container).hasClass('loading')) {
        $(container).addClass('loading')

        $.ajax({
            url: '/data/postcode',
            method: 'GET',
            data: {
                postcode: postcode,
                number: number,
                numberAddition: numberAddition,
                country: country
            }
        }).done(function (result) {
            callback(result, container);
        }).fail(function () {
            callback(false, container);
        }).always(function () {
            $(container).removeClass('loading');
        });
    }
};

Util.checkBECityAndPostcode = function (city, postcode, container, callback) {
    if (!city || !postcode || !callback) {
        return;
    }

    if (!$(container).hasClass('loading')) {
        $(container).addClass('loading')

        $.ajax({
            url: '/data/city-and-postcode',
            method: 'GET',
            data: {
                q: postcode,
            }
        }).done(function (result) {
            callback(result, container);
        }).fail(function () {
            callback(false, container);
        }).always(function () {
            $(container).removeClass('loading');
        });
    }
};

Util.getPostcodeAndCity = function (q, limit, callback) {
    if (!q) {
        return;
    }

    $.ajax({
        url: '/data/city-and-postcode',
        method: 'GET',
        data: {
            q: q,
            limit: limit
        },
        success: function (result) {
            callback(result);
        },
        error: function () {
            callback(false);
        }
    });
};

Util.cartesian = function (args) {
    let arg = [];
    $.each(args, function (index, array) {
        arg.push(array);
    });

    let r = [], max = arg.length - 1;

    function helper(arr, i) {
        for (let j = 0, l = arg[i].length; j < l; j++) {
            let a = arr.slice(0); // clone arr
            a.push(arg[i][j]);
            if (i === max) {
                r.push(a);
            }
            else {
                helper(a, i + 1);
            }
        }
    }

    helper([], 0);
    return r;
};

export default Util;

export function selectToReadOnly(el) {
    if ($('option', el).length === 1) {
        el.parent('.form-select-wrapper').addClass('readonly');
    }
}

export function respondToVisibility (element, callback, once) {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (!once) {
               return callback(entry.intersectionRatio > 0)
            }
              
            if (entry.intersectionRatio > 0) {
                callback(true)
                observer.unobserve(entry.target)
            }
        })
    }, { root: null })

    observer.observe(element)
}
